var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:{'is-error': _vm.error, 'is-success': _vm.success}},[_c('app-icon',{attrs:{"name":_vm.icon}}),_c('div',{staticClass:"message-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }